import { ApiCollections } from "@/api/collection";
import { useCollectionsData } from "./useCollectionsData";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useCollectionPageData = () => {
  const { data: collectionPage, isLoading: collectionPageLoading } = useLocalizedQuery({
    queryKey: ["collectionPage"],
    queryFn: async lang => ApiCollections.getCollectionsPage(lang),
  });

  const { collections, isLoading: collectionsLoading } = useCollectionsData();

  return {
    collectionPage: {
      collectionPage,
      loading: collectionPageLoading,
    },
    collections: {
      collections,
      loading: collectionsLoading,
    },
  };
};
